import { Component, OnInit } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { AuthService } from '@core/auth.service';
import { ModalController, NavParams } from "@ionic/angular";
import { JackpotTriggersService } from 'src/app/services/jackpot-triggers.service';

@Component({
  selector: 'app-prize-draw-lose',
  templateUrl: './prize-draw-lose.component.html',
  styleUrls: ['./prize-draw-lose.component.scss'],
})
export class PrizeDrawLoseComponent implements OnInit {
  title: string;
  languageCode: string = "en";
  description: string;
  prizeDrawLoseTranslatedData: any;
  desc1: string;
  desc2: string;
  desc3: string;
  desc4: string;
  subTitle: string;
  buttonLabel: string;
  data: any;
  userId: string;
  constructor(
    private firestore: Firestore,
    private modalCtrl: ModalController,
    private router: Router,
    private navParams: NavParams,
    private authService: AuthService,
    private jackpotTriggerService: JackpotTriggersService
  ) {
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe(
        (data) => {
          this.prizeDrawLoseTranslatedData = data?.["ln_prize_draw_lose"];
          this.title = this.prizeDrawLoseTranslatedData?.title;
          this.desc1 = this.prizeDrawLoseTranslatedData?.desc_1;
          this.desc2 = this.prizeDrawLoseTranslatedData?.desc_2;
          this.desc3 = this.prizeDrawLoseTranslatedData?.desc_3;
          this.desc4 = this.prizeDrawLoseTranslatedData?.desc_4;
          this.subTitle = this.prizeDrawLoseTranslatedData?.sub_title;
          this.buttonLabel = this.prizeDrawLoseTranslatedData?.button_label;
        },
        (err) => {
          return err;
        }
      );
    });
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("PrizeDrawLoseComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.data = this.navParams.get("message");
    const userId = this.userId;
    if (!userId || userId === "null" || !this.data?.id) {
      console.error("User ID or message data is not available.");
      return;
    }
    const path_id = "dQ2JLcXGOr5fbVp8gyIf";
    const doc_data = {
      viewed: true,
      view_count: this.data?.view_count + 1,
    };
    const dv = { docId: this.data.id };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        console.error("Error updating inbox document:", error);
        return error;
      }
    });
  }
  isBack() {
    this.modalCtrl.dismiss(true).catch((err) => {
      return err;
    });
  }
  goToSyndicate() {
    this.router.navigate([`/mainTabs/tabs/syndicate`]);
    this.isBack();
  }
}
